module.exports = __webpack_public_path__ + "img/gepuzemeltetesi_szolgaltatasok_pop_up.2ae3c0d5.png";